import { Component, OnInit, ViewChild, Output, EventEmitter, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { BsoSpecialInstructions } from '../shared/models/efs.model';
import { TableDataService } from '../shared/services/table-data.service';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { Observable } from 'rxjs';

let DATA: BsoSpecialInstructions[] = [
  {
    bsoSpecialInstructionsId: '28', blnktSlsOrderId: '71947', specialInstructionsId: '90',
    revDt: '10192018123530', revBy: 'EnterpriseFactorySetupService', facilityId: '308', fromDt: '10192018103000',
    clientId: '', blnktSlsOrderCd: '1001', facilityCd: 'BPL',
    si: {
      specialInstructionsId: '90', planTypeCd: 'B', instructionsTxt: 'PLACEHOLDER INSTRUCTION',
      revDt: '10192018123530', revBy: 'EnterpriseFactorySetupService'
    }
  }
];

@Component({
    selector: 'app-reusable-table',
    templateUrl: './reusable-table.component.html',
    styleUrls: ['./reusable-table.component.css'],
    animations: [
        trigger('selectRow', [
            state('selected', style({ backgroundColor: '#51C1E4' })),
            state('notSelected', style({ backgroundColor: 'white' })),
            transition('selected <=> notSelected', animate('525ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
            state('expanded', style({ height: '*', visibility: 'visible' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class ReusableTableComponent implements OnInit, OnDestroy /*OnChanges*/ {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;

  @Input() displayedColumns;
  @Input() columns: any[];
  @Input() updateTable;
  // toggleAnimationBool = false;

  isSelected = false;
  selectedRowIndex = -1;

  matTooltip = '';
  enableRowLinks = false;
  enableSelectableRows = false;
  disableCheckboxesColumn = true;
  disableEditColumn = true;
  disableDeleteColumn = true;
  disableIndexColumn = true;
  slices = 0;

  dataSource = new MatTableDataSource<any>(DATA);
  selection: SelectionModel<any>;

  @Output() messageEvent = new EventEmitter<any[]>();

  // private eventSubscription: any;
  @Input() events: Observable<any>;

  constructor(private tableDataService: TableDataService) { }

  ngOnInit() {
    this.sliceCheck();
    // this.eventSubscription = this.events.subscribe( data => {
    //   DATA = data;
    //   this.dataSource.data = DATA;
    //   if (this.updateTable) {
    //     this.selection.clear();
    //   }
    //   // console.log('IS THIS REAL PARENT DATA? ' + JSON.stringify(DATA));
    // });
    DATA = [];


    // if a table has embedded json, it must be added to sorting data accessor in order to sort by it
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'si.instructionsTxt': return item.si.instructionsTxt;
        case 'planTypeCd': return item.si.planTypeCd;
        default: return item[property];
      }
    };

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    const initialSelection = [];
    const allowMultiSelect = true;
    this.selection = new SelectionModel<any>(allowMultiSelect, initialSelection);
  }

  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    // this.eventSubscription.unsubscribe();
  }

  // beginning of expandable rows functions; currently not used
  getRows(tableData) {
    const rows = [];
    tableData.forEach(element => rows.push(element, { detailRow: true, element }));
    console.log(rows);
    return rows;
  }

  // toggleRow(value: Element) {
  //   const foundElement = this.dataSource.data.find(elem => elem.element !== undefined && elem.element.name === value.name);
  //   console.log('The found element is ' + JSON.stringify(foundElement));
  //   const index = this.dataSource.data.indexOf(foundElement);
  //   this.dataSource.data[index].element.show = !this.dataSource.data[index].element.show;
  // }
  toggleRow(value) {
    const foundElement = this.dataSource.data.find(elem => elem !== undefined && elem.name === value.name);
    console.log('The found element is ' + JSON.stringify(foundElement));
    const index = this.dataSource.data.indexOf(foundElement);
    this.isSelected = !this.isSelected;
    // this.dataSource.data[index].element.show = !this.dataSource.data[index].element.show;
  }

  // tslint:disable-next-line:ban-types
  isExpansionDetailRow = (i: number, row: Object) => {
    console.log(row);
    return row.hasOwnProperty('detailRow');
  }
  // end of expandable row functions

  // Toggle whether the row is selected
  toggleSelectedRow(rowIndex, row) {
    // console.log(JSON.stringify(rowIndex));
    this.selectedRowIndex = rowIndex;
    this.getHighlightRowData(row);
  }
// remove the highligthed row after sort
  removeSelect() {
    this.selectedRowIndex = -1;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
  }

  getRowData() {
    // this.messageEvent.emit(this.selection.selected);
    this.tableDataService.shareData(this.selection.selected);
  }

  getHighlightRowData(row) { // alternate way to get row data when there are no checkboxes
    this.tableDataService.shareData(row);
  }

  sliceCheck() { // if a feature is enabled, slice it off the displayed columns; false means it is enabled
    const features = [this.disableCheckboxesColumn, this.disableEditColumn, this.disableDeleteColumn, this.disableIndexColumn];
    for (const item of features) {
      if (item === false) {
        this.slices++;
      }
    }
    // console.log('SLICES ' + this.slices);
  }

  editButton(row) {

  }
  deleteButton(row) {

  }

  // toggleAnimation() { // toggles the animation for clicking a row
  //   this.toggleAnimationBool = !this.toggleAnimationBool;
  //   // console.log(this.toggleAnimationBool);
  // }
}
